import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-students-for-impact',
  templateUrl: './students-for-impact.component.html',
  styleUrls: ['./students-for-impact.component.css']
})
export class StudentsForImpactComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
